import type { CoworkerAndTeamSelectionMode } from "@repo/api";
import { t } from "@repo/translation";

export const getSelectionModeText = (
  selectionMode: CoworkerAndTeamSelectionMode
) => {
  // has coworker selection mode
  if (selectionMode.coworkerSelectionMode) {
    // has team selection mode
    if (selectionMode.selectTeamWithMembers || selectionMode.selectOnlyTeam) {
      return {
        title: t("action.select_coworker_and_team"),
        emptyStateText: t("prompt.no_coworker_or_team_selected"),
      };
    }
    // Only coworker selection mode
    return {
      title: t("action.select_coworker"),
      emptyStateText: t("prompt.no_coworker_selected"),
    };
  }
  // Only team selection mode
  if (selectionMode.selectTeamWithMembers || selectionMode.selectOnlyTeam) {
    return {
      title: t("action.select_team"),
      emptyStateText: t("prompt.no_team_selected"),
    };
  }
  return {
    title: t("action.select_coworker_and_team"),
    emptyStateText: t("prompt.no_coworker_or_team_selected"),
  };
};
